import { render, staticRenderFns } from "./TableManisfetoSaida.vue?vue&type=template&id=4c63c65e&scoped=true&"
import script from "./TableManisfetoSaida.vue?vue&type=script&lang=js&"
export * from "./TableManisfetoSaida.vue?vue&type=script&lang=js&"
import style0 from "./TableManisfetoSaida.vue?vue&type=style&index=0&id=4c63c65e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c63c65e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VContainer,VIcon})
